import { Controller } from 'stimulus'

import { haptics } from '~/common/helpers/haptics'

import { celebrateReaction } from './reaction_celebration.js'

const DOUBLE_TAP_IGNORE =
  'a, button, input, textarea, select, label, video, audio, iframe, [contenteditable], .video-js, [role=toolbar]'

let doubleTapInstalled = false

// Double-clicking (or double-tapping) inside a `[data-double-tap-react]` area
// adds the default reaction, like Instagram. It never removes a reaction, so a
// second double-tap only replays the animation.
function handleDoubleTap(event) {
  const target = event.target
  if (!(target instanceof Element) || target.closest(DOUBLE_TAP_IGNORE)) return

  // The area's own link, never one of a nested area (a comment inside a post)
  const area = target.closest('[data-double-tap-react]')
  const link = [
    ...(area?.querySelectorAll('.js-double-tap-reaction') || []),
  ].find((candidate) => candidate.closest('[data-double-tap-react]') === area)
  if (!link) return

  window.getSelection()?.removeAllRanges() // The double-click also selected a word
  celebrateReaction({
    key: link.dataset.reactionKey,
    icon: link.dataset.reactionIcon,
    x: event.clientX,
    y: event.clientY,
  })
  haptics.tap()
  if (link.dataset.reactionAdding !== 'true') return

  link.dataset.celebrated = 'true' // Already animated where the member tapped
  link.click()
}

export default class extends Controller {
  connect() {
    if (doubleTapInstalled) return
    doubleTapInstalled = true
    document.addEventListener('dblclick', handleDoubleTap)
  }

  // Plays the animation on click instead of after the server responds, so the
  // reaction feels instant.
  celebrate(event) {
    const link = event.target.closest('[data-reaction-key]')
    if (!link || link.dataset.reactionAdding !== 'true') return
    if (link.dataset.celebrated) {
      delete link.dataset.celebrated
      return
    }

    const rect = link.getBoundingClientRect()
    celebrateReaction({
      key: link.dataset.reactionKey,
      icon: link.dataset.reactionIcon,
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    })
    haptics.tap()
  }
}
